import { required, requiredIf, minLength, url } from 'vuelidate/lib/validators'

import Foerderung from './Foerderung'

const isAtLeastFrom =
  (to, vm) => {
    let from = vm.projektBeginn
    if (to && from) {
      return from <= to
    } else {
      return true
    }
  }

const isAtLeast =
  (field) =>
    (to, vm) => {
      let lowerBound = vm[field]
      if (to && lowerBound) {
        return lowerBound <= to
      } else {
        return true
      }
    }

const isAtMost =
  (field) =>
    (to, vm) => {
      let upperBound = vm[field]
      if (to && upperBound) {
        return to <= upperBound
      } else {
        return true
      }
    }

const isBetween =
  (beginn, ende) => {
    return (v) => {
      if (!beginn) {
        return false
      }
      if (v == null) {
        return true
      }
      return v >= beginn && (ende == null || v <= ende)
    }
  }

export default (beginn, ende) => {
  return {
    organisationseinheit: {
      name: { required, minLength: minLength(1) }
    },
    projektBeginn: { required },
    projektEnde: {
      isAtLeastFrom
    },
    titelDE: {
      required: requiredIf((resourceData) => resourceData.titelEN == null || resourceData.titelEN.length === 0),
      minLength: minLength(1)
    },
    titelEN: {
      required: requiredIf((resourceData) => resourceData.titelDE == null || resourceData.titelDE.length === 0),
      minLength: minLength(1)
    },
    beschreibungDE: {
      required: requiredIf((resourceData) => resourceData.beschreibungEN == null || resourceData.beschreibungEN.length === 0),
      minLength: minLength(1)
    },
    beschreibungEN: {
      required: requiredIf((resourceData) => resourceData.beschreibungDE == null || resourceData.beschreibungDE.length === 0),
      minLength: minLength(1)
    },
    externeProjektwebsite: {
      url
    },
    // projektLeiter: {
    //   name: { required, minLength: minLength(1) }
    // },
    projektleiter: {
      nonEmpty: (pl) => {
        return pl.length >= 1
      },
      $each: {
        person: {
          required,
          name: { required, minLength: minLength(1) }
        },
        startdatum: {
          withinProjectBounds: isBetween(beginn, ende),
          beforeEnddatum: isAtMost('enddatum'),
        },
        enddatum: {
          withinProjectBounds: isBetween(beginn, ende),
          afterStartDatum: isAtLeast('startdatum'),
        },
      },
    },
    foerderung: {
      $each: Foerderung
    }
  }
}



// WEBPACK FOOTER //
// ./src/validation/Forschungsprojekt.js